import {useAuth0} from "@auth0/auth0-react";
import React, {useState, useEffect} from "react";
import {makeStyles, useTheme} from "@material-ui/core";
import moment from "moment";

import PageHeader from "./blocks/PageHeader";
import PageFooter from "./blocks/PageFooter";
import TileGrid from "./controls/CardGrid";

import {getUserMetaData} from "./auth/metaData";
import AircraftGrid from "./modules/Aircraft/components/AircraftGrid";
import {useInterval} from "./functions/useInterval";
const AccessControl = require("./AccessControl");

const changeFavicon = (_favicon) => {
  let favicon = document.querySelector('link[rel="icon"]');
  // If a <link rel="icon"> element already exists,
  // change its href to the given link.
  if (favicon !== null) {
    const baseURI = favicon.baseURI ? favicon.baseURI.substring(0, favicon.baseURI.lastIndexOf("/") + 1) : window.location.hostname;
    favicon.href = `${baseURI}${_favicon}`
    // Otherwise, create a new element and append it to <head>.
  } else {
    favicon = document.createElement("link")
    favicon.rel = "icon"
    favicon.href = `${window.location.hostname}${_favicon}`
    document.head.appendChild(favicon)
  }
}


function NewHome (props) {

  let theme = useTheme();
  const signInStyles = makeStyles({
    card: {},
    rooted: {
      display: "flex",
    },
    formControl: {
      margin: theme.spacing(3),
    },
    root: {
      flexGrow: 1,
      height: 250,
    },
    container: {
      flexGrow: 1,
      position: "relative",
    },
    chip: {
      margin: theme.spacing(0.5, 0.25),
    },
    inputRoot: {
      flexWrap: "wrap",
    },
    inputInput: {
      width: "auto",
      flexGrow: 1,
    },
    divider: {
      height: theme.spacing(2),
    },
    paper: {
      zIndex: 1,
      left: 0,
      right: 0,
      marginTop: theme.spacing(1),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    avatar: {
      margin: theme.spacing(2),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    pageMargins: {
      marginLeft: "40px",
      marginRight: "40px",
      [theme.breakpoints.down("md")]: {
        marginLeft: "5px",
        marginRight: "5px",
      },
    },
  })();

  const { isAuthenticated, user } = useAuth0();
  const [state, setState] = useState({
    userName: "",
    password: "",
    newPassword: "",
    repeatNewPassword: "",
    openAlert: false,
    alertTitle: "",
    alertMessage: "",
    openForgotPassword: false,

  });

  const ZuluClock = () => {
    const theme = useTheme();
    const [zuluTime, setZuluTime] = useState (moment.utc().format("HH:mm"));

    useInterval(() => {
      setZuluTime(moment.utc().format("HH:mm"));
    }, 600);

    return (<span style={{color: theme.palette.primary.dark, fontWeight: "bolder", fontSize: 18}}>{zuluTime} Zulu</span>);
  }

  useEffect(() => {
    document.title = process.env.REACT_APP_TAB_TITLE || process.env.REACT_APP_COPYRIGHT || "Forward Momentum";
    changeFavicon(process.env.REACT_APP_FAVICON);

    const getUserRoles = async (user) => {
      await AccessControl.getUserRoles(user);
      const userInfo = await getUserMetaData(user.sub);
      if (userInfo && state.userName === "") {
        AccessControl.setUserInfo(userInfo);
        const userName = userInfo.firstName + " " + userInfo.lastName;
        const userClass = userInfo?.userClass;
        // console.log(state.userName);
        setState({...state, userName: userName, userClass: userClass});
      }
    }

    getUserRoles(user);

    setState({...state, userName: AccessControl.userName});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.userName]);

  const classes = signInStyles;

  function renderHome() {

    return (isAuthenticated &&
      <div
        className="App"
        style={{
          backgroundColor: "#eeeeee",
          color: "#1b4481",
          fontWeight: 400,
          fontFamily: "Ubuntu,sans-serif",
          minHeight: "100vh"
        }}
      >
        <PageHeader
          parentProps={props}
          activeMenuItem="home"
          pageName="Home"
          loggedInUser={user}
        ></PageHeader>
        <div
          className={classes.pageMargins}
          style={{height: 2, backgroundColor: "#b7c3d4"}}
        ></div>
        <div style={{height: 10}}></div>

        <div className={classes.pageMargins + " clearfix"} style={{display: "flex", minHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, maxHeight: `calc(100vh - ${(99+2+10+57+4)}px)`, overflow: "hidden"}} >
          <div
            // className={classes.pageMargins + " clearfix"}
            style={{backgroundColor: "#ffffff", flexGrow: 1, padding: "40px 20px 0px", overflow: "scroll"}}
          >
            <TileGrid loggedInUser={user}/>
          </div>

          {state.userClass === "OPERATOR" ? <div style={{width: 20}}></div> : <></>}
          {state.userClass === "OPERATOR"
            ?
              <div
              // className={classes.pageMargins + " clearfix"}
              style={{backgroundColor: "#ffffff", padding: "10px 10px", overflow: "scroll", minWidth: 190, maxWidth: 190}}
              >
                <ZuluClock/>
                <div style={{height: 10}}></div>
                <AircraftGrid/>
              </div>
            :
              <></>
          }
        </div>

        {/*<div style={{height: 10}}></div>*/}
        <PageFooter></PageFooter>
      </div>
    );
  }


  return renderHome();
}

export default NewHome;
